import React from "react";
import { Box, Typography } from "@mui/material";
import { ACCENT } from "../BusinessOnboard.constant";

interface IFieldLabelProps {
  label: string;
  required?: boolean;
  /** When true, removes the default bottom margin (for inline label rows). */
  noMargin?: boolean;
}

/** Uppercase micro-label above inputs, with an optional red asterisk. */
export const FieldLabel: React.FC<IFieldLabelProps> = ({
  label,
  required,
  noMargin,
}) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 0.5,
      // Fixed row height so labels with/without the asterisk match exactly.
      height: "1.1rem",
      lineHeight: "1.1rem",
      mb: noMargin ? 0 : 0.75,
    }}
  >
    <Typography
      component="span"
      sx={{
        fontSize: "0.72rem",
        fontWeight: 700,
        lineHeight: "1.1rem",
        letterSpacing: "0.06em",
        color: "text.secondary",
        textTransform: "uppercase",
        whiteSpace: "nowrap",
      }}
    >
      {label}
    </Typography>
    {required && (
      <Typography
        component="span"
        sx={{
          color: ACCENT.main,
          fontWeight: 700,
          fontSize: "0.72rem",
          lineHeight: "1.1rem",
        }}
      >
        *
      </Typography>
    )}
  </Box>
);
